var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always","height":"645px"}},_vm._l((_vm.data),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item,"alt":""}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }